import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchDeletePolicy } from "./ethicspolicyAPI";
import swal from 'sweetalert';
export interface DeletePolicyState {
  deletePolicy: Array<any>;
  status: "idle" | "loading" | "failed";
}

const initialState: DeletePolicyState = {
    deletePolicy: [],
  status: "idle",
};

export const GetDeletePolicy = createAsyncThunk(
  "DeletePolicy/fetchDeletePolicy",
  async (data:any) => {
    const response = await fetchDeletePolicy(data);
    return response;
  }
);

export const DeletePolicySlice = createSlice({
  name: "DeletePolicy",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetDeletePolicy.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetDeletePolicy.rejected, (state) => {
        state.status = "failed";
        swal("Something went wrong!",  "error");
      })
      .addCase(GetDeletePolicy.fulfilled, (state, action) => {
        state.status = "idle";
        state.deletePolicy = action.payload;
        swal("Record delete success!",  "success");
      });
  },
});

export const {} = DeletePolicySlice.actions;

export const selectDeletePolicy = (state: RootState) => {
  return state.DeletePolicy.deletePolicy;
};

export default DeletePolicySlice.reducer;
